export default "/images/vendor/@coreui/icons/svg/flag/cif-ph.svg?1783ff08e3a91f522ae5b46479071e8e";